<template>
  <div>
    <div
      class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition el-table--mini"
      style="width: 100%;    overflow: auto;"
    >
      <div class="el-table__body-wrapper is-scrolling-none">
        <el-form ref="ruleForm" :model="form" :rules="rules" :show-message="false" class="baseform">
          <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            class="el-table__body"
            style="width: 100%;"
          >
            <colgroup>
              <col name="el-table_6_column_46" width="100">
              <col name="el-table_6_column_47">
              <col name="el-table_6_column_48" width="100">
              <col name="el-table_6_column_49">
            </colgroup>
            <tbody>
              <tr class="el-table__row">
                <td class="is-center">
                  <div class="cell">
                    发运单号
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="shippingNum">
                      <el-input v-model="form.shippingNum" />
                    </el-form-item>
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    发货单号
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="fhNum">
                      <el-input v-model="form.fhNum" />
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td class="is-center">
                  <div class="cell">
                    提货单号
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="deliveryNum">
                      <el-input v-model="form.deliveryNum" />
                    </el-form-item>
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    始发国
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="sendingCountry">
                      <el-input v-model="form.sendingCountry" />
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td class="is-center">
                  <div class="cell">
                    始发港
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="sendingPort">
                      <el-input v-model="form.sendingPort" />
                    </el-form-item>
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    目的国
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="destinationCountry">
                      <el-input v-model="form.destinationCountry" />
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td class="is-center">
                  <div class="cell">
                    目的港
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="destinationPort">
                      <el-input v-model="form.destinationPort" />
                    </el-form-item>
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    国际承运商
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="internationalCarrier">
                      <el-input v-model="form.internationalCarrier" />
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td class="is-center">
                  <div class="cell">
                    提货日期
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="pickUpDate">
                      <el-date-picker v-model="form.pickUpDate" type="date" value-format="yyyy-MM-dd" />
                    </el-form-item>
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    报关日期
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="customsDeclarationDate">
                      <el-date-picker v-model="form.customsDeclarationDate" type="date" value-format="yyyy-MM-dd" />
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td class="is-center">
                  <div class="cell">
                    离境日期
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="departureDate">
                      <el-date-picker v-model="form.departureDate" type="date" value-format="yyyy-MM-dd" />
                    </el-form-item>
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    抵港日期
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="arrivalDate">
                      <el-date-picker v-model="form.arrivalDate" type="date" value-format="yyyy-MM-dd" />
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td class="is-center">
                  <div class="cell">
                    清关日期
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="customsClearanceDate">
                      <el-date-picker v-model="form.customsClearanceDate" type="date" value-format="yyyy-MM-dd" />
                    </el-form-item>
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    派送日期
                  </div>
                </td>
                <td class="is-center">
                  <div class="cell">
                    <el-form-item prop="deliveryDate">
                      <el-date-picker v-model="form.deliveryDate" type="date" value-format="yyyy-MM-dd" />
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td class="is-center">
                  <div class="cell">
                    物流签收单
                  </div>
                </td>
                <td colspan="3">
                  <el-upload
                    action=""
                    multiple
                    :show-file-list="false"
                    :http-request="uploadaction"
                  >
                    <el-button type="text">
                      选择文件
                    </el-button>
                  </el-upload>
                  <ul class="el-upload-list el-upload-list--text">
                    <el-row :gutter="60">
                      <el-col v-for="(item ,index) in fileList" :key="index" :span="12" class="el-col-auto">
                        <li tabindex="0" class="el-upload-list__item is-success">
                          <a class="el-upload-list__item-name">
                            <i class="el-icon-document" />
                            {{ item.fileName }}
                          </a>
                          <label v-if="!item.loading" class="el-upload-list__item-status-label">
                            <i class="el-icon-upload-success el-icon-circle-check" />
                          </label>
                          <i class="el-icon-close" @click="removeFile(item ,index)" />
                          <el-progress v-if="item.loading" style="margin-top: 5px" :percentage="item.percentage" :stroke-width="4" :show-text="false" />
                        </li>
                      </el-col>
                    </el-row>
                  </ul>
                </td>
              </tr>
              <tr class="el-table__row">
                <td class="is-center">
                  <div class="cell">
                    备注
                  </div>
                </td>
                <td colspan="3">
                  <div class="cell">
                    <el-input
                      v-model="form.remark"
                      type="textarea"
                      :rows="2"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </el-form>
      </div>
    </div>
    <div style="text-align: right;margin:20px 10px 20px 0">
      <el-button type="default" :loading="loading" @click="$emit('cancel')">
        取消
      </el-button>
      <el-button type="primary" :loading="loading" @click="submit">
        确定
      </el-button>
    </div>
  </div>
</template>

<script>
import axios, { saveIntelLogistics, updateIntelLogistics, getIntelLogisticsDetail } from '@/API/international';
import { attachmentGetToken } from '@/API';
export default {
  props: {
    ediRow: {
      type: Object,
      default: () => { return null; }
    }
  },
  data () {
    return {
      form: {
        shippingNum: '',
        deliveryNum: '',
        sendingCountry: '',
        sendingPort: '',
        destinationCountry: '',
        destinationPort: '',
        internationalCarrier: '',
        pickUpDate: '',
        customsDeclarationDate: '',
        departureDate: '',
        arrivalDate: '',
        customsClearanceDate: '',
        deliveryDate: '',
        remark: ''
      },
      rules: {
        shippingNum: [
          { required: true, trigger: 'blur' }
        ],
        deliveryNum: [
          { required: true, trigger: 'blur' }
        ],
        fhNum: [
          { required: true, trigger: 'blur' }
        ],
        sendingCountry: [
          { required: false, trigger: 'blur' }
        ],
        sendingPort: [
          { required: false, trigger: 'blur' }
        ],
        destinationCountry: [
          { required: false, trigger: 'blur' }
        ],
        destinationPort: [
          { required: false, trigger: 'blur' }
        ],
        internationalCarrier: [
          { required: false, trigger: 'blur' }
        ],
        pickUpDate: [
          { required: false, trigger: 'change' }
        ],
        customsDeclarationDate: [
          { required: false, trigger: 'change' }
        ],
        departureDate: [
          { required: false, trigger: 'change' }
        ],
        arrivalDate: [
          { required: false, trigger: 'change' }
        ],
        customsClearanceDate: [
          { required: false, trigger: 'change' }
        ],
        deliveryDate: [
          { required: false, trigger: 'change' }
        ]
      },
      loading: false,
      submitfile: [],
      fileList: [],
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: ''
    };
  },
  methods: {
    submit () {
      this.$refs.ruleForm.validate().then(() => {
        let filelist = [];
        this.fileList.forEach((item) => {
          if (item.status === 'success') {
            filelist.push({
              id: item.id,
              fileName: item.fileName,
              fileToken: item.fileToken
            });
          }
        });
        this.loading = true;
        let pr = new Promise(() => {});
        if (this.ediRow) {
          pr = updateIntelLogistics({
            ...this.form,
            intelLogisticsAttachmentList: filelist
          });
        } else {
          pr = saveIntelLogistics({
            ...this.form,
            intelLogisticsAttachmentList: filelist
          });
        }
        pr.then((res) => {
          this.loading = false;
          const { status, data } = res.data;
          if (status === '200') {
            this.$emit('success');
            this.$notify.success(data);
          }
        });
      }).catch(() => {
        this.$notify.error('请填写完整信息');
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    uploadaction (upload) {
      let form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      let myfile = {
        fileName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.fileList.push(myfile);
      axios.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        let json = res.data;
        myfile.loading = false;
        if (json.status === '200') {
          myfile.status = 'success';
          myfile.fileName = json.data[0].FullName;
          myfile.fileToken = json.data[0].FID;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch((e) => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    removeFile (item, index) {
      this.fileList.splice(index, 1);
    }
  },
  mounted () {
    this.initToken();
    if (this.ediRow) {
      this.form = this.ediRow;
      getIntelLogisticsDetail({
        id: this.form.id
      }).then((res) => {
        const { status, data } = res.data;
        if (status === '200') {
          data.intelLogisticsAttachmentList.forEach((item) => {
            item.status = 'success';
          });
          this.fileList = data.intelLogisticsAttachmentList;
        }
      });
    }
  }
};
</script>

<style>
.el-drawer__body{
  overflow: auto;
}
.baseform .el-form-item{
  margin-bottom: 0;
}
</style>
